import script from "./QrView.vue?vue&type=script&setup=true&lang=ts"
export * from "./QrView.vue?vue&type=script&setup=true&lang=ts"

import "./QrView.vue?vue&type=style&index=0&id=a985915c&lang=css"

const __exports__ = script;

export default __exports__